import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

//enviroments
import { ENVIRONMENT } from 'src/environments/environment';
//services
import { AuthDataService } from '../ui/services/auth-data.service';
//interfaces
import { BodyData, CustomDataEvent, FastDataAmplitudeResponse, FastDataBody } from   '../dto/fast-data';
import { IEventTrackingPort } from 'src/app/domain/ports/i-event-tracking-port';
import { CustomAmplitudeEvent } from 'src/app/domain/models/amplitude.model';
import { DownloadsEventsEnum } from '../ui/enums/amplitude';

@Injectable({
  providedIn: 'root'
})
export class FastDataAdapterService implements IEventTrackingPort {

  private fastDataConfig = ENVIRONMENT.urls.fastData;

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/x-amz-json-1.1'
    }),
  };

  constructor(
    private http: HttpClient,
    private authDataService: AuthDataService) {
  }
  
  trackEvent(event: string, customEvent?: CustomDataEvent) {
    const userData = this.authDataService.getUserData();
    const timestamp = new Date().getTime();

    const bodyData: BodyData = {
      uid: userData.uidCms,
      timestamp: timestamp,
      category: 'comercio_event',
      domain: 'comercios',
      priority: 'alta',
      event: {
        session_id: this.authDataService.sessionId,
        eventName: event,
        uid: userData.uidCms,
        codPais: userData.countryCode,
        nombreComercio: userData.commerceName,
        userName: userData.userName,
        nombreCategoria: userData.categoryName,
        idComercio: userData.idCommerce,
      }
    }

    if (customEvent) {
      bodyData.event = {
        ...bodyData.event,
        ...customEvent
      };
    }

    const fastDataBody: FastDataBody = {
      Data: btoa(JSON.stringify(bodyData)),
      PartitionKey: this.fastDataConfig.partitionKey,
      StreamName: this.fastDataConfig.streamName
    }

    return this.http.post<any>(this.fastDataConfig.api, fastDataBody, this.httpOptions).subscribe()
  }

  downloadEvent(eventName: DownloadsEventsEnum, customEvent?: CustomAmplitudeEvent) {

    const userData = this.authDataService.getUserData();
    const timestamp = new Date().getTime();

    const bodyData: BodyData = {
      uid: userData.uidCms,
      timestamp: timestamp,
      category: 'comercio_event',
      domain: 'comercios',
      priority: 'alta',
      event: {
        eventName: eventName,
        categoriaNombre: userData.categoryName,
        codPais: userData.countryCode,
        nombreComercio: userData.commerceName,
        nombreSucursal: userData.commerceName,
        uid: userData.uidCms,
        userName: userData.userName,
        idRole: userData.idRole,
        idComercio: userData.idCommerce,
        session_id: this.authDataService.getSessionId(),
      }
    }

    if (customEvent) {
      bodyData.event = {
        ...bodyData.event,
        ...customEvent
      };
    }

    const fastDataBody: FastDataBody = {
      Data: btoa(JSON.stringify(bodyData)),
      PartitionKey: this.fastDataConfig.partitionKey,
      StreamName: this.fastDataConfig.streamName
    }

    return this.http.post<FastDataAmplitudeResponse>(this.fastDataConfig.api, fastDataBody, this.httpOptions)

    
  }

}
